// src/components/PromoOffer.jsx
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import NewCustomerPromotionForm from "./newCustomerPromoForm";
import PromoImage from "../assets/images/promotions/gentleman-reading.jpg";

/**
 * Reusable red-tab → fullscreen modal.
 *
 * Props:
 *  - tabText: string ("Get 20% Off")
 *  - imageSrc: string (right-side image URL)
 *  - imageAlt: string
 *  - open?: boolean           // optional controlled mode
 *  - onOpenChange?: (bool) => void
 */
const PromoOffer = ({
  tabText = "Get 20% Off",
  imageSrc = PromoImage,
  imageAlt = "Promotion",
  open: controlledOpen,
  onOpenChange,
}) => {
  // Uncontrolled fallback if not using controlled props
  const [uncontrolledOpen, setUncontrolledOpen] = useState(false);
  const open = controlledOpen ?? uncontrolledOpen;
  const setOpen = onOpenChange ?? setUncontrolledOpen;

  // Lock body scroll + ESC to close
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    if (open) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", onKey);
    } else {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    }
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, setOpen]);

  return (
    <>
      {/* Red Tab (manual open) */}
      <button
        type="button"
        className="promo-tab"
        aria-label={tabText}
        onClick={() => setOpen(true)}
      >
        {tabText}
      </button>

      {/* Fullscreen Modal via portal (reliable z-index, outside stacking contexts) */}
      {open &&
        createPortal(
          <div
            className="promo-modal"
            role="dialog"
            aria-modal="true"
            aria-label="Promotion sign-up"
            onClick={() => setOpen(false)} // backdrop closes
          >
            <div
              className="promo-modal__content"
              onClick={(e) => e.stopPropagation()} // clicks inside don't close
            >
              <button
                type="button"
                className="promo-modal__close"
                aria-label="Close"
                onClick={() => setOpen(false)}
              >
                ×
              </button>

              {/* Left: Form */}
              <div className="promo-modal__left">
                <div className="promo-modal__left-inner">
                  <h2 className="mb-3 fw-bold">Claim Your Welcome Discount</h2>
                  <p className="text-muted mb-4">
                    New here? Pop in your details below and grab your first-time code.
                  </p>
                  <NewCustomerPromotionForm />
                </div>
              </div>

              {/* Right: Image */}
              <div className="promo-modal__right" aria-hidden="true">
                <img src={imageSrc} alt={imageAlt} />
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};

export default PromoOffer;
